module.exports = __webpack_public_path__ + "img/5129.115e580d.jpg";